import { Alert } from "@mui/material";

import { useAnalytics } from "@/providers/analytics";
import { LinkButton } from "@/shared/foundation/primitives";
import { PanelState } from "@/shared/state/visualization";

import { useEphemeralWorkspaceState } from "../WorkspaceCtx";

import styles from "./NoDataMessage.module.css";

interface EmptyDataNoticeProps {
  panelData: PanelState["data"];

  /** Call to action to add data to the panel */
  onAddDataAction?: () => void;
}

export function NoDataMessage({
  panelData,
  onAddDataAction,
}: EmptyDataNoticeProps) {
  const { trackEvent } = useAnalytics();
  const { isHydrating } = useEphemeralWorkspaceState();
  if (isHydrating) {
    return null;
  }

  if (
    panelData === null ||
    (typeof panelData === "object" && Object.keys(panelData).length === 0)
  ) {
    return (
      <Alert className={styles.center} severity="info">
        Drag in a message path from the topic list{" "}
        {onAddDataAction && "or click "}
        {onAddDataAction && (
          <>
            <LinkButton
              className={styles.link}
              onClick={() => {
                trackEvent("AddDataClicked");
                onAddDataAction();
              }}
            >
              Add Data
            </LinkButton>{" "}
          </>
        )}
        to start.
      </Alert>
    );
  }

  return null;
}
